import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/onemoreSzechuan/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="One More SzechuanFacebook"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#C60000" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/onemoreSzechuan/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="One More SzechuanFacebook"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.yelp.ca/biz/ogenki-sushi-vancouver">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="One More SzechuanYelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/ogenki-sushi-riley-park-little-mountain-vancouver">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="One More SzechuanZomato"
                hover
              />
            </CFLink> */}
            {/* <CFLink href="https://www.instagram.com/applausesushi/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="One More SzechuanInstagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
